import { X, CheckCircle, ArrowsClockwise } from "@phosphor-icons/react";

export default function ExerciseInfoModal({ exercise, exMap, onClose, onSwap }) {
  if (!exercise) return null;
  const alternates = (exercise.alternates || []).map((id) => exMap[id]).filter(Boolean);

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 grid place-items-center p-4" onClick={onClose} data-testid="exercise-info-modal">
      <div className="bg-card border border-border w-full max-w-3xl max-h-[88vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-card border-b border-border px-5 py-3 flex items-center justify-between z-10">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="px-2 py-1 bg-volt text-black label-mono">{exercise.domain}</span>
            <span className="px-2 py-1 border border-border label-mono">{exercise.level}</span>
            <span className="px-2 py-1 border border-border label-mono">{exercise.equipment}</span>
          </div>
          <button onClick={onClose} data-testid="exercise-info-close" className="text-muted-foreground hover:text-foreground"><X size={20} weight="bold" /></button>
        </div>

        <div className="p-5">
          <h2 className="font-display text-3xl font-black mb-1 leading-none">{exercise.name}</h2>
          <div className="text-xs text-muted-foreground mb-5">Targets: {exercise.muscle_groups?.join(" · ")}</div>

          <div className="label-mono mb-3">// EXECUTION CUES — {exercise.instructions?.length || 0} STEPS</div>
          <ol className="space-y-3 text-sm">
            {exercise.instructions?.map((line, i) => (
              <li key={`${i}-${line.slice(0, 24)}`} className="flex gap-3 border border-border bg-background p-3">
                <div className="shrink-0 w-7 h-7 grid place-items-center bg-volt text-black font-display font-black">{i + 1}</div>
                <span className="leading-relaxed">{line}</span>
              </li>
            ))}
          </ol>
        </div>

        {alternates.length > 0 && (
          <div className="border-t border-border p-5">
            <div className="label-mono mb-3">// ALTERNATES — swap by skill or kit</div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {alternates.map((a) => (
                <div key={a.id} className="border border-border bg-background p-3 flex flex-col gap-2" data-testid={`alt-info-${a.id}`}>
                  <div className="label-mono text-volt">{a.level} · {a.equipment}</div>
                  <div className="font-display text-sm font-bold uppercase leading-tight">{a.name}</div>
                  <div className="text-xs text-muted-foreground line-clamp-3">{a.instructions?.[0]}</div>
                  {onSwap && (
                    <button
                      onClick={() => onSwap(a.id)}
                      className="mt-auto inline-flex items-center justify-center gap-1 border border-volt text-volt px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-volt hover:text-black transition-colors"
                      data-testid={`swap-to-${a.id}`}
                    >
                      <ArrowsClockwise size={12} weight="bold" /> Swap to this
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
